export default "__VITE_ASSET__DWm$N_hf__";